import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IInfo, Info } from '../../../../../core/common';
import { IV6OptionValueTranslation, V6OptionValueTranslation } from '../../../../../core/models';
import { ProductService } from '../../../../../core/services/product.service';

@Component({
  selector: 'app-edit-value-translation',
  templateUrl: './edit-value-translation.component.html',
  styleUrls: ['./edit-value-translation.component.scss']
})
export class EditValueTranslationComponent implements OnInit {

  constructor(private productService: ProductService,
    private router: Router,
    private route: ActivatedRoute) {
    if (this.productService.editValueTranslation && this.productService.editValueTranslation.id) {
      this.editValueTranslation = this.productService.editValueTranslation;
      this.value = this.productService.editValueTranslation.optionValueApplicableProducts.split('|');
    } else {
      this.router.navigate(['../'], { relativeTo: this.route });
    }
  }

  ngOnInit() {
    this.productService.GetProductCode().subscribe(productCodeResponse => {
      this.productCode = productCodeResponse;
      this.dummyProductCode = this.productCode;
    });
  }
  editValueTranslation: IV6OptionValueTranslation = new V6OptionValueTranslation();
  public value: any = [];
  productCode = [];
  dummyProductCode = [];
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public infoMessage: IInfo = new Info();
  isSubmitted: boolean = false;
  saveInProcess: boolean = false;
  validateForm(): boolean {
    return true;
  }

  handleFilter(event) {
    let keys = Array.from(this.dummyProductCode.values());
    this.productCode = keys.filter(
      (s) => s ? s.toLowerCase().indexOf(event.toLowerCase()) !== -1 : false
    );
  }

  editValueTranslationToSave(): void {
    this.isSubmitted = true;
    if (this.value) {
      this.editValueTranslation.optionValueApplicableProducts = this.value.join("|");
    }
    this.editValueTranslation.active = true;
    //return;
    if (!this.validateForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.genericInProgress;
    this.productService.AddValueTranslation(this.editValueTranslation).subscribe(response => {
      if (response) {
        this.infoMessage.genericInProgress = "";
        this.saveInProcess = false;
        this.infoMessage.genericSuccess = this.infoMessage.genericSuccess;
      } else {
        this.infoMessage.genericError = this.infoMessage.genericError;
      }
      this.editValueTranslation = new V6OptionValueTranslation();
      this.value = [];
    });
  }

}
